module.exports = __webpack_public_path__ + "static/txtagif-7ed17bf6e27376160a21adf5231a6bfd.png";